module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<input class="form-control ui-input-search" type="search" autocomplete="off" placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'">\n<div class="icon-wrapper">\n    <i class="icon ion-search"></i>\n    <div class="spinner hide"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./js/ui/form/searchInput/template.ejs
// module id = 362
// module chunks = 3